import { z } from 'zod';

import { DepartmentDtoSchema } from '~modules/department/dto';

export const PositionDtoScheme = z.object({
	id: z.string().describe('Идентификатор должности из 1C'),
	name: z.string().describe('Наименование должности'),
});

export type PositionDto = z.infer<typeof PositionDtoScheme>;

export const StaffingDtoScheme = z.object({
	id: z.number().describe('Идентификатор'),
	department_id: z.string().describe('Идентификатор подразделения'),
	organization_id: z.string().describe('Идентификатор юр. лица'),
	position_id: z.string().describe('Идентификатор должности'),
	department: DepartmentDtoSchema.describe('Подразделение').nullable().optional(),
	position: PositionDtoScheme.describe('Должность').nullable().optional(),
	name: z.string().describe('Наименование'),
});

export type StaffingDto = z.infer<typeof StaffingDtoScheme>;
